import React from 'react';

import { Placement } from '@floating-ui/react';
import classNames from 'classnames';

import { WithTooltip } from '../WithTooltip';

export type Props = {
  children: React.ReactNode;
  disabledMessage?: false | string;
  position?: Placement;
  disabled?: boolean;
  widthTooltip?: string;
  disabledTriggerClassName?: string;
  small?: boolean;
  fixedFloating?: boolean;
  fullwidth?: boolean;
};

export const ActionDisabledWithTooltip: React.FC<Props> = ({
  children,
  position,
  disabledMessage,
  disabled,
  widthTooltip,
  disabledTriggerClassName,
  small,
  fixedFloating = true,
  fullwidth,
}) =>
  disabledMessage && disabled ? (
    <WithTooltip
      fixedFloating={fixedFloating}
      trigger={
        <div className={classNames('relative', { 'w-full': fullwidth }, disabledTriggerClassName)}>
          {children}
        </div>
      }
      position={position}
      width={widthTooltip ?? 'auto'}
      small={small}
    >
      <div className="text-b3">{disabledMessage}</div>
    </WithTooltip>
  ) : (
    <>{children}</>
  );
